import script from "./FileViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileViewer.vue?vue&type=script&setup=true&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=cd81816e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd81816e"]])

export default __exports__